export default "__VITE_ASSET__WWsfUxNR__"